import React from 'react'
import { Tooltip } from 'recharts'

import * as Styled from './Tooltip.styled'
import { getFormattedDate } from '../../helpers'

const renderTooltipContent = ({ active, payload, label }) => {
  if (!active || !payload?.length) {
    return null
  }

  return (
    <Styled.Tooltip>
      <Styled.Label>{getFormattedDate(new Date(label))}</Styled.Label>
      <Styled.Delimiter />
      {payload.map(({ stroke, color, value, unit, name }) => (
        <Styled.Legend key={name}>
          <Styled.Dot color={stroke ?? color} />
          <span>{`${value}${unit ? ` ${unit}` : ``}`}</span>
        </Styled.Legend>
      ))}
    </Styled.Tooltip>
  )
}

const CustomTooltip = (props?: any) => <Tooltip content={renderTooltipContent} {...props} />

export default CustomTooltip
